export enum DocumentActionType {
  FETCH_DOCUMENTS = 'FETCH_DOCUMENTS',
  FETCH_BULK_DOCUMENTS = 'FETCH_BULK_DOCUMENTS',
  FETCH_DDTV_DOCUMENT = 'FETCH_DDTV_DOCUMENT',
  FETCH_LOGISTIC_DOCUMENTS = 'FETCH_LOGISTIC_DOCUMENTS'
}
